import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  inset: 0; /* inset sets all 4 values (top right bottom left) much like how we set padding, margin etc., */
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 999;
`;

export const ModalContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.text.light};

  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 50px auto;
  border-radius: 0.5rem;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colors.text.dark};
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: auto;
  justify-content: center;
  align-items: center;
  & > h2 {
    font-size: 2rem;
    grid-column: 2/3;
    flex: 1;
  }
  & > span {
    cursor: pointer;
    grid-column: 3/4;
    display: flex;
    justify-self: end;
    padding: 0.5rem;
  }
`;

export const ModalContent = styled.div`
  position: relative;
  overflow-y: auto;
`;
